// extracted by mini-css-extract-plugin
module.exports = {"conversation_room_bg":"index-module__conversation_room_bg___2MDEJ","back":"index-module__back___Hf4+3","flagged_message":"index-module__flagged_message___aQl2j"};